/**
 * @copyright (C) 2025, rsupport. All rights reserved
 *
 * @license
 * This software and/or source code may be used, copied and/or disseminated only
 * with the written permission of rsupport, or in accordance with the terms
 * and conditions stipulated in the agreement/contract under which the software
 * and/or source code has been supplied by rsupport or its affiliates.
 * Unauthorized use, copying, or dissemination of this file, via any medium, is
 * strictly prohibited, and will constitute an infringement of copyright.
 *
 * @author
 * Heeseok Shin (hsshin@rsupport.com)
 *
 * @description
 *
 * @created at Mon Apr 28 2025
 **/

import { useCachedQuery } from "@/frameworks/core/API/private/useCachedQuery";
import { formatfetchedMyRoom, formatfetchedOpenWorld, formatfetchedSpaceDetail } from "../../persistence";
import { SpaceService } from "../../API";
import MyRoomServiceAPI from "../../API/user/useMyRoom/MyRoomServiceAPI";

export function useSpaceList() {
	return useCachedQuery({
		queryKey: ["space", "mySpaces"],
		queryFn: async () => {
			const { data } = await new SpaceService({}).space.mySpaces.list.execute();
			return data;
		}
	});
}

export function useSpaceState(spaceID: SPACE_ID, spaceType: "MY_ROOM" | "GROUP_SPACE" | "OPEN_WORLD") {
	return useCachedQuery({
		queryKey: ["space", spaceID, spaceType],
		queryFn: async () => {
			switch (spaceType) {
				case "MY_ROOM": {
					const { data } = await MyRoomServiceAPI.getInstance({}).myRoom.inquiry.execute({
						myRoomId: spaceID
					});
					return formatfetchedMyRoom(data);
				}
				case "GROUP_SPACE": {
					const { data } = await new SpaceService({}).space.detail.execute({ spaceId: spaceID });
					return formatfetchedSpaceDetail(data);
				}
				case "OPEN_WORLD": {
					const { data } = await new SpaceService({}).space.detail.execute({ spaceId: spaceID });
					return formatfetchedOpenWorld(data);
				}
			}
		}
	});
}
